export default {"src":"/_next/static/media/apple_pay_icon.3fab9993.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};